import React from 'react';
import { ColorModeProvider } from './ColorModeSelect';

interface AppThemeProps {
    children: React.ReactNode;
}

export default function AppTheme(props: AppThemeProps) {
    const { children } = props;

    return <ColorModeProvider>{children}</ColorModeProvider>;
}
